import styled from 'styled-components';
import {GameIconWrapperBox} from "../../../../basic-components/game-icon-wrapper/game-icon-wrapper.box";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";

interface IGameIconWrapperBoxProps {
    useSquareIcons: boolean;
}

export const DefaultBox = styled(GameIconWrapperBox)<IGameIconWrapperBoxProps>`
        height: ${props => props.useSquareIcons ? '190px' : '130px'};
        width: 130px;
        border-radius: 15px;
        overflow: hidden;
`;

const PcBox = DefaultBox;

const MobileBox = styled(DefaultBox)`
    height: ${props => props.useSquareIcons ? '170px' : '115px'};
    width: 115px;
    @media ${({theme}) => theme.mediaQuery.xs} {
        padding-left: 0;
        width: 115px;
    }
`;

export const GameIconContainerDefaultBox = styledByDevice(PcBox, MobileBox);
